const key = sfEnv['recaptchaKey']
const disable = sfEnv['recaptchaDisable']

const getReCaptchaToken = function (action) {

    if (disable) return;

    return new Promise((resolve, reject) => {
         
        if (!window['grecaptcha']) {
            reject('reCAPTCHA is not initiliased')
        }

        if (!key) {
            reject('reCAPTCHA key is missing')
        }

        grecaptcha.enterprise.ready(function () {
            try {
                grecaptcha.enterprise.execute(key, {action: action || 'form_submit'})
                    .then(token => resolve(token))
                    .catch(e => reject(e))
            } catch (e) {
                console.error(e)
                reject('reCAPTCHA Error')
            }
        }, reject)
    })
}

export {
    getReCaptchaToken
}
